import { AfterViewInit, Component, ContentChildren, ElementRef, inject, Input, input, output, QueryList, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnTemplateDirective } from './ui-table-column.directive';

//import {CdkDrag,CdkDragPreview, CdkDragDrop, CdkDragEnd} from '@angular/cdk/drag-drop'; //this need to be installed "@angular/cdk": "^20.2.14", in dependecies package.json



@Component({
  selector: 'ui-table',
  imports: [NgTemplateOutlet],
  templateUrl: './ui-table.html',
  styleUrl: './ui-table.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})


export class UiTable<T> implements AfterViewInit {

  readonly title = input<string>('---');
  readonly data = input<T[]>([]);
  readonly columns = input<{ key: string; label: string; }[]>([]);

  sortColumn = [null, null] as [string | null, 'asc' | 'desc' | null];
  sortColumnChange = output<[string | null, 'asc' | 'desc' | null]>();

  @ContentChildren(ColumnTemplateDirective)
  templates!: QueryList<ColumnTemplateDirective>;

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }


  getTemplate(columnName: string): TemplateRef<any> | undefined {
    return this.templates.find(t => t.columnKey === columnName)?.templateRef;
  }

  toggleSorting(columnKey: string) {

    if (this.sortColumn[0] === columnKey) {
      switch (this.sortColumn[1]) {
        case null:
          this.sortColumn = [columnKey, 'asc'];
          break;
        case 'asc':
          this.sortColumn = [columnKey, 'desc'];
          break;
        case 'desc':
          this.sortColumn = [null, null];
          break;
        default:
          break;
      }
    } else {
      this.sortColumn = [columnKey, 'asc'];
    }

    this.sortColumnChange.emit(this.sortColumn);
  }
}